import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['digit', 'code'];

  connect() {
    this.#syncCode();
  }

  fill(event) {
    const index = this.digitTargets.indexOf(event.target);
    const inserted = this.#digitsOf(event.data ?? '');
    const digits = this.#digitsOf(event.target.value);

    if (digits.length <= 1) {
      this.#write(digits, index);
      return;
    }

    if (inserted.length === 1) {
      this.#write(inserted, index);
      return;
    }

    this.#writeCode(inserted || digits, index);
  }

  focusPrevious(event) {
    if (event.key !== 'Backspace' || event.target.value !== '') return;

    this.digitTargets[this.digitTargets.indexOf(event.target) - 1]?.focus();
  }

  fillFromClipboard(event) {
    const digits = this.#digitsOf(event.clipboardData?.getData('text') ?? '');
    if (digits.length === 0) return;

    this.#writeCode(digits, this.digitTargets.indexOf(event.target));
  }

  selectDigit(event) {
    if (!this.digitTargets.includes(event.target)) return;

    event.target.select();
  }

  #writeCode(digits, index) {
    const lastStart = this.digitTargets.length - digits.length;

    this.#write(digits, Math.max(0, Math.min(index, lastStart)));
  }

  #write(digits, from) {
    this.digitTargets
      .slice(from, from + Math.max(digits.length, 1))
      .forEach((input, offset) => { input.value = digits.charAt(offset); });

    if (digits.length > 0) this.#focusAfter(from + digits.length - 1);
    this.#syncCode();
  }

  #focusAfter(index) {
    this.digitTargets[Math.min(index + 1, this.digitTargets.length - 1)].focus();
  }

  #digitsOf(text) {
    return text.replace(/\D/g, '').slice(0, this.digitTargets.length);
  }

  #syncCode() {
    this.codeTarget.value = this.digitTargets.map((input) => input.value).join('');
  }
}
